import notificationType from './report-notification-type.constant'
import { BaseModel } from '../base-model';

/**
 * 
 */
export interface INotificationModel {
  Type?: number
  Title?: string
  Content?: string 
  Data?: any
  DateTime?: Date
}

/**
 * 
 */
export class NotificationModel extends BaseModel<INotificationModel>  implements INotificationModel {
  Type: number
  Title: string
  Content: string 
  Data: any
  DateTime: Date

  /**
   *
   */
  constructor(option?: INotificationModel) {
    super(option);
    this.Type = option.Type || notificationType.Unknow;
    this.Title = option.Title || null
    this.Content = option.Content || null
    this.Data = option.Data || null
    this.DateTime = option.DateTime || null;
  }
}

